import styled, { css } from 'styled-components';

interface RootProps {
  oddEvenBg?: boolean;
}

export const Root = styled.span<RootProps>`
  padding: 3px 5px;
  ${(props) =>
    props.oddEvenBg &&
    css`
      &:nth-child(even) {
        background-color: #eff1fb;
      }
    `}
`;

export const Label = styled.strong`
  white-space: pre;
  text-transform: capitalize;
`;
